import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormUp = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormUp' {...props}>
    <polyline fill='none' stroke='#000' strokeWidth='2' points='18 9 12 15 6 9' transform='matrix(1 0 0 -1 0 24)' />
  </StyledIcon>
);
